import { inject } from '@angular/core';
import { RedirectCommand, ResolveFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, firstValueFrom, map, take } from 'rxjs';

import { Group } from '@models';
import { GroupService } from '@services';
import { AppState } from '@store';

export const groupResolver: ResolveFn<Nullable<Group>> = async (route) => {
  const groupService = inject(GroupService);
  const router = inject(Router);
  const store: Store<AppState> = inject(Store);

  return firstValueFrom(
    groupService.getGroup(route.params.id).pipe(
      catchError(() =>
        store
          .select((state) => state.auth.isLoggedIn)
          .pipe(
            take(1),
            map((isLoggedIn) =>
              isLoggedIn ? new RedirectCommand(router.parseUrl('/404')) : null
            )
          )
      )
    )
  );
};
